import { UserAccountRegActionDto, UserAccountRegDto } from "src/app/core/dtos/dto";
import { RegAction } from "./action";
import { Injectable } from '@angular/core';
import { ConfigHelper } from "src/app/core/services/helpers/config.helper";

@Injectable()
export class ActionHelper {
  launchSRDownload: boolean;
  launchScoringTimelineSwitch: number;
  brandId: number;

  DOWNLOAD_TICKET = "/account/download-ticket";
  ORDER_TEST_RE_EVALUATION = "/account/order-test-re-evaluation";
  ORDER_ONE_SKILL_RETAKE = "/account/order-one-skill-retake";
  VIEW_RECEIVING_INSTITUTIONS = "/account/view-receiving-institutions";
  POST_REG_PHOTO_UPLOAD = "/account/post-reg-photo-upload";
  TRANSFER_REGISTRATION = "/account/transfer-registration";
  CANCEL_REGISTRATION = "/account/cancel-registration";
  SCORE_REPORT_OPTIONS = "/account/score-report-options";
  PRETEST_DISCOUNT_REFUND_REQUEST = "/account/pretest-discount-refund-request";
  PRETEST_DISCOUNT_REQUEST = "/account/pretest-discount-request";
  WEB_DELIVERY_ACTION = "/account/web-delivery-actions";
  TEST_TAKER_COMPLAINT = "/account/test-taker-complaint";

  constructor(
    private configHelper: ConfigHelper
  ) {
    this.brandId = this.configHelper.getBrandId();
    this.launchSRDownload = this.configHelper.getLaunchSRDownload() === 1;
    this.launchScoringTimelineSwitch = this.configHelper.getLaunchSoringTimelineSwitch();
  }

  getRegistrationActions(actions: UserAccountRegActionDto, reg: UserAccountRegDto, isUpcomingTest: boolean): RegAction[] {
    const regActions = [];
    if (actions.canEditScoreReportOptions) {
      regActions.push({
        text: "<i class=\"fa fa-envelope-o\"></i>&nbsp;Update Score Recipients",
        url: this.buildUrl(this.SCORE_REPORT_OPTIONS, reg.regId) + "/" + reg.testTypeId + "/" + reg.isWebDelivery
      });
    }

    if (actions.canViewReceivingInstitutions) {
      regActions.push({
        text: "<i class=\"fa fa-angle-double-right\"></i>&nbsp;View Score Recipients",
        url: this.buildUrl(this.VIEW_RECEIVING_INSTITUTIONS, reg.regId)
      });
    }

    if (actions.canOrderOneSkillRetake) {
      regActions.push({
        text: "<i class=\"fa fa-angle-double-right\"></i>&nbsp;Register for a One Skill Retake",
        url: this.buildUrl(this.ORDER_ONE_SKILL_RETAKE, reg.regId)
      });
    }

    if (actions.canOrderReEvaluation) {
      regActions.push({
        text: "<i class=\"fa fa-angle-double-right\"></i>&nbsp;Request Test Re-evaluation",
        url: this.buildUrl(this.ORDER_TEST_RE_EVALUATION, reg.regId)
      });
    }

    if (actions.canPostRegPhotoUpload) {
      regActions.push({
        text: "<i class=\"fa fa-exchange\"></i>&nbsp;Photo Upload ",
        url: this.buildUrl(this.POST_REG_PHOTO_UPLOAD, reg.regId)
      });
    }

    if (actions.canTransfer) {
      regActions.push({
        text: "<i class=\"fa fa-exchange\"></i>&nbsp;Transfer to a Different Sitting",
        url: this.buildUrl(this.TRANSFER_REGISTRATION, reg.regId)
      });
    }

    if (actions.canApplyDiscount) {
      regActions.push({
        text: "<i class=\"fa fa-envelope-o\"></i>&nbsp;Request Discount Code",
        url: this.buildUrl(this.PRETEST_DISCOUNT_REQUEST, reg.regId) + "/" + reg.testTypeId
      });
    }

    if (actions.canApplyDiscountRefund) {
      regActions.push({
        text: "<i class=\"fa fa-envelope-o\"></i>&nbsp;Request Refund or Discount Code",
        url: this.buildUrl(this.PRETEST_DISCOUNT_REFUND_REQUEST, reg.regId) + "/" + reg.testTypeId
      });
    }

    if (actions.canCancel) {
      regActions.push({
        text: "<i class=\"fa fa-times\"></i>&nbsp;Cancel Test Registration",
        url: this.buildUrl(this.CANCEL_REGISTRATION, reg.regId)
      });
    }

    if (actions.canDownloadTestAdmissionTicket) {
      regActions.push({
        text: "<i class=\"fa fa-cloud-download\"></i>&nbsp;Download Test Admission Ticket",
        url: this.buildUrl(this.DOWNLOAD_TICKET, reg.regId)
      });
    }

    if (actions.isWebDelivery && actions.canOnlineTestActions && !isUpcomingTest) {
      regActions.push({
        text: "<i class=\"fa fa-external-link-square\"></i>&nbsp;Online Test Requirements",
        url: this.buildUrl(this.WEB_DELIVERY_ACTION, reg.regId)
      });
    }

    if (actions.canSubmitComplaints) {
      regActions.push({
        text: "<i class=\"fa fa-angle-double-right\"></i>&nbsp;Report a Test Day Issue",
        url: this.buildUrl(this.TEST_TAKER_COMPLAINT, reg.regId)
      });
    }

    return regActions;
  }

  buildUrl(url: string, regId: number): string {
    return url + "/" + regId;
  }

}
